<template>
  <main class="page-brands page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_set_emails" class="btn__add"
          >通知邮箱地址</el-button
        >
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="接口名称:">
          <el-input v-model="filter.apiName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="actionName:">
          <el-input v-model="filter.actionName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="接口类型:">
          <el-select style="width: 110px;" v-model="filter.portType" placeholder="定制系统类型">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="标准接口" :value="1"></el-option>
            <el-option label="项目接口" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="审核状态:">
          <el-select v-model="filter.auditStatus" style="width: 110px;" placeholder="请选择">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="审核中" :value="1"></el-option>
            <el-option label="审核通过" :value="2"></el-option>
            <el-option label="审核不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px;"
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >查无该运营商，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px;"
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >查无该品牌，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="供应商:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px;"
              v-model="filter.supplierName"
              :fetch-suggestions="$_getSuppliersConfig"
              :trigger-on-focus="false"
              value-key="supplierName"
              @select="$_selectSupplier"
            ></el-autocomplete>
            <div
              v-show="!searchSuppliersData.length && filter.supplierName"
              @click="$_clearSearchData('supplier')"
              class="autocomplete-empty el-select-dropdown"
            >查无该供应商，请重新输入</div>
          </div>
        </el-form-item>

        <el-form-item label="订阅名称:">
          <el-input v-model="filter.uniqueName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="创建人:">
          <el-input v-model="filter.creatorName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="创建时间:">
          <el-date-picker
            v-model="filter.createTime"
            type="datetimerange"
            range-separator=" - "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions"
            @blur="$_clearDate"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="审核人:">
          <el-input v-model="filter.auditPersonName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="审核时间:">
          <el-date-picker
            v-model="filter.auditTime"
            type="datetimerange"
            range-separator=" - "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions"
            @blur="$_clearDate"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="140" :resizable="false">
          <template slot-scope="scope">
            <el-button
              class="edit__btn"
              @click="$_modify(scope.row, 2)"
              v-if="scope.row.auditStatus==1"
            >审核</el-button>
            <el-button class="edit__btn" @click="$_modify(scope.row, 1)" v-else>查看</el-button>
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getBrandList"
      ></cd-pagination>
    </div>
    <!-- 设置邮箱 -->
    <set-emails
      v-if="modal.show && modal.template === 'set-emails'"
      :title="modal.title"
      :modalData="modal.data"
      @close="$_close"
    ></set-emails>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import setEmails from "./modal-set-emails";

const columns = [
  { key: "apiName", label: "接口名称", width: 120 },
  { key: "actionName", label: "actionName", width: 160 },
  {
    key: "auditStatus",
    label: "审核状态",
    width: 120,
    component: "statusTmpl"
  },
  { key: "portType", label: "接口类型", width: 120, component: "sendTypeTmpl" },
  { key: "platformName", label: "运营商名称", width: 120 },
  { key: "brandName", label: "品牌名称", width: 120 },
  { key: "supplierName", label: "供应商", width: 140 },
  { key: "uniqueName", label: "订阅名称", width: 140 },
  { key: "auditPersonName", label: "审核人", width: 100 },
  { key: "auditTime", label: "审核时间", width: 160 },
  { key: "creatorName", label: "创建人", width: 100 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operatorName", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 }
];
let minPickerDate = "";
let maxPickerDate = "";
export default {
  name: "audits-api-audits",
  mixins: [resize],
  data() {
    return {
      isLoading: false,
      filter: {
        apiName: "",
        actionName: "",
        portType: 0,
        auditStatus: 0,
        createStartTime: "",
        createEndTime: "",
        createTime: [],
        auditStartTime: "",
        auditEndTime: "",
        auditTime: [],
        platformName: "",
        platformKey: "",
        brandName: "", // 品牌名称
        brandId: 0, // 品牌brandId
        viewName: "",
        creatorName: "",
        auditPersonName: "",
        supplierName: "",
        supplierId: 0, // 供应商ID
        uniqueName: ""
      },
      searchBrandData: [],
      searchSuppliersData: [], // 供应商列表
      searchSubscribeData: [], // 订阅名称列表

      searchPlatformData: [],
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        template: "",
        postData: {}
      },
      pickerOptions: {
        disabledDate(date) {
          let today = Utils.formatDate(new Date(), "yyyy-MM-dd");
          let smaller = Date.parse(today) + 1000 * 60 * 60 * 16 - 1;
          if (maxPickerDate && maxPickerDate < smaller) {
            smaller = maxPickerDate - 1000 * 60 * 60 * 8 - 1; // 每天的时间以8点为始点
          }
          return date.getTime() > smaller || date.getTime() < minPickerDate;
        },
        onPick({ minDate, maxDate }) {
          if (maxDate === null) {
            let min = Utils.formatDate(minDate, "yyyy-MM-dd");
            minPickerDate = Date.parse(min) - 1000 * 60 * 60 * 8; // 每天的时间以8点为始点
            maxPickerDate = Date.parse(min) + 1000 * 60 * 60 * 24 * 7;
          } else {
            minPickerDate = "";
            maxPickerDate = "";
          }
        }
      }
    };
  },
  watch: {
    "filter.platformName"(val) {
      !val && (this.filter.platformKey = "");
    },
    "filter.brandName"(val) {
      if (!val) this.filter.brandId = 0;
    },
    "filter.supplierName"(val) {
      if (!val) this.filter.supplierId = 0;
    }
  },
  methods: {
    // 还原时间跨度数值
    $_clearDate() {
      minPickerDate = "";
      maxPickerDate = "";
    },
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999
      };
      this.$service.post("getBrands", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = 0;
    },
    // 下拉联想数据为空时 对应数据重置
    $_clearSearchData(key) {
      this.filter[`${key}Name`] = "";
      this.filter[`${key}Id`] = 0;
    },
    // 下拉联想供应商列表数据
    $_getSuppliersConfig(supplierName, cb) {
      // getSuppliersConfig - searchSuppliersData
      this.$service
        .post("getSuppliersConfig", {
          pageNow: 1,
          pageSize: 20,
          // status: 1,	// !是否只需返回状态开户的供应商
          supplierName
        })
        .then(result => {
          if (result.$.checkResult(result, true)) {
            let rows = result.data.rows.concat([]);
            this.searchSuppliersData = rows;
            cb(rows);
          }
        });
    },
    // 选择对应供应商
    $_selectSupplier(item) {
      this.filter.supplierName = item.supplierName;
      this.filter.supplierId = item.cid;
    },
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      let postData = {
        platformName: platformName,
        pageNow: 1,
        pageSize: 9999
      };
      this.$service.post("getPlatformList", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.searchPlatformData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
      this.filter.platformKey = item.platformKey;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getBrandList();
    },
    // 重置
    $_reset() {
      minPickerDate = "";
      this.filter.createStartTime = "";
      this.filter.createEndTime = "";
      this.filter.createTime = [];
      this.filter.auditStartTime = "";
      this.filter.auditEndTime = "";
      this.filter.auditTime = [];
      this.filter.apiName = "";
      this.filter.actionName = "";
      this.filter.portType = 0;
      this.filter.platformKey = "";
      this.filter.platformName = "";
      this.filter.auditStatus = 0;
      this.filter.brandId = 0;
      this.filter.brandName = "";
      this.filter.supplierName = "";
      this.filter.uniqueName = "";
      this.filter.viewName = "";
      this.filter.creatorName = "";
      this.filter.auditPersonName = "";
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$nextTick(() => {
        this.$_getBrandList();
      });
    },
    // 查询订阅关系列表
    $_getBrandList() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      let {
        apiName,
        actionName,
        portType,
        auditStatus,
        platformKey,
        brandId,
        creatorName,
        auditPersonName,
        supplierId, // 供应商id
        uniqueName, // 订阅名称
        createTime: [createStartTime, createEndTime],
        auditTime: [auditStartTime, auditEndTime]
      } = this.filter;
      let { pageNow, pageSize } = this.pagination;
      const postData = {
        apiName,
        actionName,
        portType,
        auditStatus,
        platformKey,
        brandId,
        creatorName,
        auditPersonName,
        supplierId,
        uniqueName,
        createStartTime,
        createEndTime,
        auditStartTime,
        auditEndTime,
        pageNow,
        pageSize
      };
      this.$service.post("portAuditPaging", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 新增/编辑成功回调
    $_callback() {
      this.$_getBrandList();
    },
    // 查看/编辑
    async $_modify(row, $index) {
      let formType = $index == 1 ? "read" : "edit";
      let name = $index == 1 ? "auditDetailComponent" : "editComponent";

      this.$emit("changeTab", {
        name,
        formType,
        contData: JSON.parse(JSON.stringify(row)),
        from: "auditComponent"
      });
    },

    $_set_emails(){
      this.modal.title = "修改默认邮箱";
      this.modal.template = "set-emails";
      this.$service.post("getPortAuditNoticeMailbox").then(result => {
        if (result.$.checkResult(result, true)) {
          this.modal.data = result.data;
          this.modal.show = true;
        }
      });
      
    },
    // 关闭选择品牌
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },

    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getBrandList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getBrandList();
    }
  },
  async mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getBrandList();
  },
  components: {
    setEmails,
    statusTmpl: {
      template: `
        <span v-if="row.auditStatus===1">审核中</span>
        <span v-else-if="row.auditStatus===2">审核通过</span>
        <span v-else style="color: #EA2A2A;">审核不通过</span>
      `,
      props: { row: { type: Object, required: true } }
    },
    sendTypeTmpl: {
      template: `
        <span v-if="row.portType===1">标准接口</span>
        <span v-else-if="row.portType===2">项目接口</span>
      `,
      props: { row: { type: Object, required: true } }
    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  margin: 20px 16px 24px 20px;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
  height: 100%;
  border: 1px solid #eee;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px;
  .filter-form {
    .el-form-item {
      margin-top: 12px;
    }
  }
  .top-btns{
    min-height: 40px;
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>
<style lang="scss">
.page-app-logs {
  .filter-box {
    .el-input {
      width: 110px;
      &.el-date-editor {
        width: 140px;
      }
    }
  }
}
</style>
